import React from 'react';
import { TOME_VIBES, type TomeVibe } from './tomeVibes';

/** The resolved vibe of the nearest TomePanel; folios and entries read their defaults from it. */
export const TomeVibeContext = React.createContext<TomeVibe>(TOME_VIBES.default);

export const useTomeVibe = (): TomeVibe => React.useContext(TomeVibeContext);
